import { getLaunchDarklyFlag } from '../feature-flags'
import { LaunchDarklyVariations } from '../feature-flags/models'
import { NotificationChannel } from '../notification-channel'
import { ShellWebSocketNotificationHandlerFactory } from './shell-websocket-notification-handler'
import type { NotificationChannel as INotificationChannel } from '@goto/shell-notification-channel'
import { NotificationChannelBuilder } from '@goto/shell-notification-channel'
import { getCurrentEnvironment } from '../../environments'
import { authenticatedFetch } from '../auth'
import { getShellLogger } from '../../common/logger'

export const createNotificationChannel = (externalUserKey: string): INotificationChannel => {
  if (getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_NOTIFICATION_CHANNEL_V2)) {
    const builder = new NotificationChannelBuilder()
    const handlerFactory = new ShellWebSocketNotificationHandlerFactory()

    return builder
      .withEnvironment(getCurrentEnvironment())
      .withExternalUserKey(externalUserKey)
      .withFactory(handlerFactory.create)
      .withFetch(authenticatedFetch)
      .withLogger(getShellLogger())
      .build()
  }
  return new NotificationChannel(externalUserKey) as INotificationChannel
}
